<template>
  <div class="visualizer-info">
    <v-icon @click="zoomClicked(-1)" size=25 class="icons plus-icon">mdi-plus-circle-outline</v-icon>
    <v-icon @click="zoomClicked(1)" size=25 class="icons minus-icon">mdi-minus-circle-outline</v-icon>
    <v-icon @click="arrowClicked('x', -50)" size=25 class="icons left-icon">mdi-arrow-left-bold-outline</v-icon>
    <v-icon @click="arrowClicked('y', -50)" size=25 class="icons up-icon">mdi-arrow-up-bold-outline</v-icon>
    <v-icon @click="arrowClicked('x', 50)" size=25 class="icons right-icon">mdi-arrow-right-bold-outline</v-icon>
    <v-icon @click="arrowClicked('y', 50)" size=25 class="icons down-icon">mdi-arrow-down-bold-outline</v-icon>
    <v-icon @click="centerClicked()" size=25 class="icons center-icon">mdi-record-circle-outline</v-icon>
  </div>
</template>
<script>
export default {
  name: 'VisualizerController',
  methods: {
    zoomClicked(val) {
      this.$emit('zoomScene', val);
    },
    centerClicked() {
      this.$emit('centerScene');
    },
    arrowClicked(axis, amount) {
      this.$emit('moveScene', {axis, amount});
    },
  }
};
</script>
<style>
.icons {
  position: fixed !important;
  color: #197F9F !important;
  cursor: pointer;
  z-index: 2;
  outline: none !important;
  box-shadow: none !important;
}
.plus-icon, .minus-icon {
  margin-left: 72px;
}
.plus-icon {
  margin-top: 5px;
}
.minus-icon {
  margin-top: 34px;
}
.left-icon {
  margin-left: 3px;
}
.up-icon, .down-icon, .center-icon {
  margin-left: 24px;
}
.left-icon, .right-icon, .center-icon {
  margin-top: 19px;
}
.up-icon {
  margin-top: -2px;
}
.right-icon {
  margin-left: 45px;
}
.down-icon {
  margin-top: 40px;
}
.visualizer-info {
  width: 100px;
  left: 253px;
  height: 64px;
  position: fixed !important;
  bottom: 20px;
  box-shadow: 0 0px 1px 0 rgba(0, 0, 0, 0.15), 0 1px 5px 0 rgba(0, 0, 0, 0.15);
  background-color: white;
  z-index: 2;
  border-radius: 9px;
}
@media only screen and (max-width: 1400px) {
  .visualizer-info {
    left: 256px;
  }
}
@media only screen and (max-width: 959px) {
  .visualizer-info {
    left: 15px;
    bottom: 15px;
  }
}
@media only screen and (max-width: 480px) {
  .visualizer-info {
    left: 10px;
    bottom: 10px;
  }
}
</style>
